import { render, staticRenderFns } from "./videoMeta.vue?vue&type=template&id=754c6ea6&scoped=true"
import script from "./videoMeta.vue?vue&type=script&lang=js"
export * from "./videoMeta.vue?vue&type=script&lang=js"
import style0 from "./videoMeta.vue?vue&type=style&index=0&id=754c6ea6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754c6ea6",
  null
  
)

export default component.exports